import { TENTATIVE_PENDING_VOUCHER_BASE_URL } from '../config';

const TENTATIVE_VOUCHER_ORIGIN = TENTATIVE_PENDING_VOUCHER_BASE_URL;

const TENTATIVE_VOUCHER_URL = `${TENTATIVE_PENDING_VOUCHER_BASE_URL}/`;

export default function openHoldVoucherWithData(payload, { timeoutMs = 30000 } = {}) {
    const targetOrigin = TENTATIVE_VOUCHER_ORIGIN;
    const url = TENTATIVE_VOUCHER_URL;

    return new Promise((resolve, reject) => {
        const voucherWindow = window.open(url, '_blank');
        if (!voucherWindow) {
            reject(new Error('Popup blocked. Allow popups for this site to open the voucher app.'));
            return;
        }

        let timer;
        function handleMessage(event) {
            console.log('SOURAV_JOSHI: event', event);
            if (event.source !== voucherWindow) return;
            if (event.origin !== targetOrigin) return;
            if (event.data?.type !== 'VOUCHER_APP_READY') return;

            clearTimeout(timer);
            console.log('SOURAV_JOSHI: Received VOUCHER_APP_READY');
            console.log('SOURAV_JOSHI: payload', payload);
            voucherWindow.postMessage({ type: 'VOUCHER_DATA', payload }, targetOrigin);
            window.removeEventListener('message', handleMessage);
            resolve();
        }

        timer = setTimeout(() => {
            window.removeEventListener('message', handleMessage);
            reject(new Error('Timed out waiting for the voucher app to load.'));
        }, timeoutMs);

        window.addEventListener('message', handleMessage);
    });
}
